import { EntityType } from '@frontend/common';
import { accountIdFromResolvedEntity } from '@frontend/components/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { EquipmentStateBadge } from '@frontend/equipment/badge';
import { EquipmentStateSelectV2 } from '@frontend/equipment/select';
import { EquipmentExtended } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';
import { ProductExtended } from '@frontend/product/types';

import { PlatformObjectBadge } from '../../../../modal/platform-object-badge/platform-object-badge.component';
import { useEquipmentDetail } from './equipment-detail.controller';

export interface EquipmentDetailProps {
    product: ProductExtended;
}

export const EquipmentDetail = (props: EquipmentDetailProps) => {
    const viewProps = useEquipmentDetail(props);

    return (
        <ReactiveObjectList<EquipmentExtended>
            label={CommonMessage.OBJECTS.EQUIPMENT.PLURAL}
            customHeaderComponent={
                <div className='pe-5 pt-4'>
                    <EquipmentStateSelectV2
                        hideLabel
                        value={viewProps.equipmentState}
                        onSelect={(v) => viewProps.setEquipmentState(v?.value || null)}
                        isClearable
                    />
                </div>
            }
            fetch={() => Promise.resolve({ count: 0, results: [] })}
            dispatch={viewProps.dispatch}
            columns={{
                columns: ['equipment', 'tag', 'state'],
                customCells: new Map([
                    [
                        'equipment',
                        (obj) => (
                            <td className={defaultCellClassName}>
                                <PlatformObjectBadge
                                    entityType={EntityType.EQUIPMENT}
                                    id={obj.row.original.id}
                                    key={obj.row.original.id}
                                />
                            </td>
                        )
                    ],
                    [
                        'tag',
                        (obj) => (
                            <td className={defaultCellClassName}>
                                <PlatformObjectBadge
                                    display={obj.row.original.tag?.name}
                                    entityType={EntityType.TAG}
                                    id={obj.row.original.tag?.entity_id}
                                    key={obj.row.original.tag?.entity_id}
                                    foreign={obj.row.original.tag?.foreign}
                                    accountId={accountIdFromResolvedEntity(obj.row.original.tag)}
                                />
                            </td>
                        )
                    ],
                    [
                        'state',
                        (obj) => <td className={defaultCellClassName}>{obj.row.original.state && <EquipmentStateBadge state={obj.row.original.state} />}</td>
                    ]
                ])
            }}
            type={EntityType.EQUIPMENT}
            id='equipment-detail-equipment-list'
            useStaticListId
            tableProps={{ hideFooter: true, defaultHeight: true }}
        />
    );
};
